import { colors, strings } from "assets/constants";
import { Text } from "components";
import React from "react";
import { StyleSheet, View } from "react-native";

export default function CatAttrBox(props: { attr: CategoryAttributeT }) {
  const { attr } = props;

  return (
    <>
      <Text style={{ lineHeight: 28 }}>
        {" "}
        {attr?.items?.map((a: AttributeItemT) => a?.value).join(" , ")}
      </Text>
      {attr.is_variable === 1 && (
        <View style={styles.attrContent}>
          <Text size={"sm"} style={{ top: -2 }} color={colors.textColorDark}>
            {strings.effective_in_variation_with_ratio}
            <Text weight="bold" size={"lg"}>
              {" "}
              {attr?.price_ratio}
            </Text>
          </Text>
        </View>
      )}
    </>
  );
}

const styles = StyleSheet.create({
  attrContent: {
    height: 22,
    marginTop: 5,
    borderRadius: 2,
    alignSelf: "flex-end",
    paddingHorizontal: 5,
    backgroundColor: colors.lightButtons,
  },
});
